/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type DoCheck, type OnInit, Component, EventEmitter, Input, Output } from '@angular/core';
import { type ContentHandler } from 'app/feature/monitor/performance-anomaly/performance-anomaly';

import { type MessageTipModle } from '../auth';
@Component({
    selector: 'app-message-tip',
    templateUrl: './message-tip.component.html',
    styleUrls: ['./message-tip.component.scss'],
})
export class MessageTipComponent implements OnInit, DoCheck {
    /**
     * 极简模式
     */
    @Input() simpleMode = false;
    // 接收的消息提醒类型信息
    @Input() type: string;
    // 接收的消息提醒文字信息
    @Input() content: string;
    // 接收的消息提醒实践操作数组信息
    @Input() handler: Array<any>;
    // 接收的消息提醒实践操作数组信息
    @Input() showCloseBtn = false;
    /**关闭回调 */
    @Output() closeEmit = new EventEmitter<void>();
    @Input() contentHandler: Array<ContentHandler>;

    messageTip: MessageTipModle;

    showMessageTip = true;

    ngOnInit(): void {
        this.initContent();
    }

    // 每次更改后执行
    ngDoCheck(): void {
        this.initContent();
    }

    // 初始化messagetip 信息
    initContent(): void {
        this.messageTip = {
            type: this.type,
            content: this.content,
            handler: this.handler,
        };
    }

    // 关闭
    onCloseClick(): void {
        this.closeEmit.emit();
        this.showMessageTip = false;
    }
}
